import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useFollowedPathProjects } = getCRUDHooks({
  entityName: 'followedPathProjects',
  find: ({
    userId,
    learningActivityStatus,
  }: {
    userId?: number;
    learningActivityStatus: Array<string>;
  }) =>
    userId &&
    clientApi
      .getOCClient()
      .helpers.learningActivity.followedPath.findProjects(userId, learningActivityStatus),
});
// eslint-disable-next-line import/prefer-default-export
export { useFollowedPathProjects };
